import {Provider} from './provider/Provider';

const AddressService = {
  addressDetail: (addressId) => {
    return Provider({
      addressId,
      methodName: 'Module/Addresses/PanelAdressDetail',
    });
  },
  userAddressList: (userId) => {
    return Provider({
      userId,
      methodName: 'Module/Addresses/UserAddressList',
    });
  },
}

export default AddressService